<template>

  <div class="mod-mps-schedule">

    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">

      <el-form-item label="计划单号"><el-input v-model="q.mpsScheduleCode" size="small" clearable /></el-form-item>

      <el-form-item label="审核">

        <el-select v-model="q.approveStatus" size="small" clearable style="width:100px">

          <el-option label="草稿" value="0" /><el-option label="已审" value="2" />

        </el-select>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('production:mpsSchedule:list')" type="primary" size="small" @click="search">查询</el-button>

        <el-button v-if="isAuth('production:mpsSchedule:save')" type="primary" size="small" @click="open()">新增</el-button>

      </el-form-item>

    </el-form>

    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">

      <el-table-column type="index" width="50" header-align="center" align="center" />

      <el-table-column prop="mpsScheduleCode" label="计划单号" min-width="130" header-align="center" align="left">

        <template slot-scope="s"><span class="code-link" @click="open(s.row, true)">{{ s.row.mpsScheduleCode }}</span></template>

      </el-table-column>

      <el-table-column prop="scheduleDate" label="业务日期" width="110" header-align="center" align="center">

        <template slot-scope="s">{{ (s.row.scheduleDate || '').slice(0, 10) }}</template>

      </el-table-column>

      <el-table-column prop="planStartDate" label="计划起" width="110" header-align="center" align="center">

        <template slot-scope="s">{{ (s.row.planStartDate || '').slice(0, 10) || '—' }}</template>

      </el-table-column>

      <el-table-column prop="planEndDate" label="计划止" width="110" header-align="center" align="center">

        <template slot-scope="s">{{ (s.row.planEndDate || '').slice(0, 10) || '—' }}</template>

      </el-table-column>

      <el-table-column prop="approveStatus" label="审核" width="80" header-align="center" align="center">

        <template slot-scope="s">{{ s.row.approveStatus === '2' ? '已审' : '草稿' }}</template>

      </el-table-column>

      <el-table-column label="操作" width="90" header-align="center" align="center">

        <template slot-scope="s">

          <el-button v-if="isAuth('production:mpsSchedule:delete') && s.row.approveStatus !== '2'" type="text" size="small" @click="remove(s.row)">删除</el-button>

        </template>

      </el-table-column>

    </el-table>

    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"

      layout="total, sizes, prev, pager, next" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />



    <mps-schedule-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />

  </div>

</template>



<script>

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'

import MpsScheduleAddOrUpdate from './mpsSchedule-add-or-update.vue'



export default {

  name: 'MpsSchedule',

  components: { MpsScheduleAddOrUpdate },

  data() {

    return {

      q: { mpsScheduleCode: '', approveStatus: '' }, list: [], pageIndex: 1, pageSize: 20, loading: false,

      addOrUpdateVisible: false, permCodes: [],

      headStyle: { background: '#f5f7fa', color: '#606266' }

    }

  },

  computed: {

    filtered() {

      const code = (this.q.mpsScheduleCode || '').trim()

      return this.list.filter(row => {

        if (code && String(row.mpsScheduleCode || '').indexOf(code) < 0) return false

        if (this.q.approveStatus && String(row.approveStatus) !== this.q.approveStatus) return false

        return true

      })

    },

    total() { return this.filtered.length },

    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }

  },

  created() { this.loadPerms(); this.load() },

  methods: {

    remove(row) {

      this.$confirm('确定删除这张未审核主生产计划?', '提示', { type: 'warning' }).then(() => {

        request.post('/plan/mps/delete', { id: row.mpsScheduleId }).then(() => { this.$message.success('已删除'); this.load() }).catch(() => {})

      }).catch(() => {})

    },

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },

    search() { this.pageIndex = 1; this.load() },

    load() {

      this.loading = true

      request.get('/plan/mps/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })

    },

    open(rowOrId, readonly) {

      this.addOrUpdateVisible = true

      this.$nextTick(() => {

        const go = (row) => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(row || null, !!readonly)

        if (rowOrId == null || rowOrId === '') { go(null); return }

        const id = typeof rowOrId === 'object' ? rowOrId.mpsScheduleId : rowOrId

        if (!id) { go(typeof rowOrId === 'object' ? rowOrId : null); return }

        request.get('/plan/mps/info', { params: { id: String(id) } }).then(res => {

          go(res.data || (typeof rowOrId === 'object' ? rowOrId : { mpsScheduleId: String(id) }))

        }).catch(() => go(typeof rowOrId === 'object' ? rowOrId : { mpsScheduleId: String(id) }))

      })

    }

  }

}

</script>



<style scoped>

.list-pagination { margin-top: 12px; text-align: right; }

.toolbar >>> .el-form-item { margin-bottom: 8px; }

.code-link { color: #348adb; cursor: pointer; }

</style>


